import { RootState } from 'store/reducers'

export const selectStoreEventType = (state: RootState) =>
  state.storeEvent.eventType
